export { setCookie, getCookie, eraseCookie }

function setCookie(key, value) {
    const timestamp = new Date().getTime(); // current time
    const exp = timestamp + (60 * 60 * 24 * 1000 * 7)
    var cookie = getCookie();
    if (!cookie)
        document.cookie = key + "=" + (value) + "; expires=" + exp + ";";
}

function getCookie(key) {

    let cookieName = key + `=`;
    let cookieArray = document.cookie.split(';');

    for (let cookie of cookieArray) {
        while (cookie.charAt(0) == ' ')
            cookie = cookie.substring(1, cookie.length);

        if (cookie.indexOf(cookieName) == 0) {
            return cookie.substring(cookieName.length, cookie.length);
        }
    }
    return null;
}

function eraseCookie(key) {
    document.cookie = key + '=; Max-Age=-99999999;';
}


